export default __webpack_public_path__ + "static/media/default_topping.30d4e9c4.png";